import { render, staticRenderFns } from "./Points.vue?vue&type=template&id=f82850a4&scoped=true"
import script from "./Points.vue?vue&type=script&lang=js"
export * from "./Points.vue?vue&type=script&lang=js"
import style0 from "./Points.vue?vue&type=style&index=0&id=f82850a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82850a4",
  null
  
)

export default component.exports